<div
  class="shop-card mb-3 rounded-lg bg-primary-lightest p-3"
  *ngFor="let prv of reviews">
  <div class="sc-header mb-5">
    <div class="content flex justify-center gap-3">
      <div class="shop flex flex-1 items-center gap-3">
        <div class="shop-img-wrapper">
          <div
            class="c-img-r aspect-square w-10 overflow-hidden rounded-full object-cover">
            <img
              [src]="prv.logo_path ? prv.logo_path : shopDefaultImg"
              (error)="handleShopImgError()" />
          </div>
        </div>
        <div class="shop-info flex-1">
          <div class="shop-name font-bold">
            {{ prv.shop_name }}
          </div>
          <div class="date block lg:hidden">{{ prv.formatted_order_date }}</div>
        </div>
      </div>
      <div class="date hidden lg:block">
        <div class="label text-sm text-primary-darkest/50">Order Date</div>
        <div class="date">{{ prv.formatted_order_date || '-' }}</div>
      </div>
    </div>
  </div>
  <div class="sc-body">
    <div class="review-list flex flex-col gap-y-4">
      <div class="review-item" *ngFor="let rv of prv.reviews">
        <div class="product flex gap-x-5">
          <div class="product-img-wrapper w-24">
            <img
              (click)="navigateToProductDetail(rv)"
              [src]="rv.product.default_image_path[0].small.path"
              alt=""
              class="product-img scale-95 cursor-pointer rounded-lg border border-primary-md-dark bg-white hover:scale-125 hover:duration-500"
              (error)="handleProductImgError()" />
          </div>
          <div class="product-info">
            <div class="brand text-sm font-semibold text-amber-600">
              {{ rv.product.brand.name }}
            </div>
            <div class="name font-semibold text-primary-darkest">
              {{ rv.product.name }}
            </div>
            <div class="variant text-sm" *ngIf="rv.variant_name">
              Varian: {{ rv.variant_name }}
            </div>
            <div class="product-review space-y-3">
              <div class="rating-wrapper">
                <div class="star">
                  <fa-icon
                    [icon]="faStar"
                    *ngFor="let _ of [1, 2, 3, 4, 5]"
                    [ngClass]="{
                      'text-gray-400': _ >= rv.rate,
                      'text-yellow-500': _ <= rv.rate
                    }"></fa-icon>
                </div>
              </div>
              <div class="review text-sm capitalize">"{{ rv.review }}"</div>
              <swiper
                class="review-images-wrapper swiper-container"
                [slidesPerView]="'auto'"
                [spaceBetween]="15">
                <ng-template
                  swiperSlide
                  class="swiper-slide review-images relative w-fit"
                  *ngFor="let img of rv.images">
                  <img
                    class="review-img aspect-square w-16 rounded-md border border-primary-md-dark object-contain"
                    [src]="img ? img : productDefaultImg"
                    (error)="handleProductImgError()" />
                </ng-template>
              </swiper>
              <!-- <div class="product-img-wrapper w-24">
                <img
                  [src]="rv.images"
                  class="product-img rounded-lg border border-primary-md-dark bg-white" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="load-more flex justify-center" *ngIf="!hideLoadMore">
  <button
    type="button"
    class="px-3 py-2 text-primary-darkest hover:rounded-lg hover:bg-primary-light"
    (click)="loadReview()"
    [disabled]="loadMoreLoading">
    <span class="btn-label"
      >Show more <fa-icon class="ml-1" [icon]="faChevronDown"></fa-icon
    ></span>
  </button>
</div>
<div *ngIf="loadMoreLoading" class="flex justify-center">
  <fa-icon
    class="load-icon text-primary-darkest"
    [icon]="faSpinner"
    [spin]="true"></fa-icon>
</div>
